import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { formatSavedAddress } from "@/pages/Replacement/steps/ChooseDelivery/address.mapper";
import { useReplacementDraftStore } from "@/pages/Replacement/use-replacement-draft-store";
import { REVIEW_STRING_KEYS } from "./review.constants";
import { SummaryBlock } from "./summary-block";

export interface DeliverySummaryBlockProps {
  onEdit: () => void;
}

const CHOOSE_DELIVERY_STRINGS = "replacement.chooseDelivery";

export const DeliverySummaryBlock: FC<DeliverySummaryBlockProps> = ({ onEdit }) => {
  const { deliveryMethod, pickup, pickupPhone, shippingAddress, homeAddress } = useReplacementDraftStore();

  const pickupLine = (): string | undefined => {
    if (!pickup) return undefined;
    const methodLabel = getString(`${CHOOSE_DELIVERY_STRINGS}.pickupMethods.${pickup.deliveryMethod}`);
    return `${methodLabel} (${pickup.buildingCode})`;
  };

  // The friendly pickup building name is resolved from the shipment-options response (OQ-9); until that
  // lookup exists the pickup line shows the method and building code held in the draft.
  const lines =
    deliveryMethod === "pickup"
      ? [
          getString(`${CHOOSE_DELIVERY_STRINGS}.pickup.title`),
          pickupLine(),
          pickupPhone && `+${pickupPhone.phoneCountryCode} ${pickupPhone.phoneNumber}`,
          homeAddress && formatSavedAddress(homeAddress),
        ]
      : [
          getString(`${CHOOSE_DELIVERY_STRINGS}.ship.title`),
          shippingAddress && formatSavedAddress(shippingAddress),
          shippingAddress?.deliveryInstructions,
        ];

  return (
    <SummaryBlock
      heading={getString(REVIEW_STRING_KEYS.deliveryHeading)}
      lines={lines.filter((line): line is string => Boolean(line))}
      onEdit={onEdit}
      editLabel={getString(REVIEW_STRING_KEYS.edit)}
      editAccessibleName={getString(REVIEW_STRING_KEYS.editDelivery)}
      dataTestId="review-delivery-summary"
    />
  );
};
